/**
 * 处理树形数据的工具函数
 */

/**
 * 调用 iteratee 遍历 tree 中的每个元素(深度优先)
 * 当迭代器return false时，结束递归
 * @param {Array} tree - 树形数据
 * @param {Function} iterator - 迭代器
 * @param {String} childrenKey - 子级数据对应的key
 * @param {Number} level - 当前迭代层级，这个参数不需要传
 */
export function depthTraversal(tree = [], iterator = () => {}, childrenKey = 'children', level = 0) {
  if (!Array.isArray(tree)) return

  for (const i in tree) {
    const item = tree[i]
    const result = iterator(item, level)
    // 当迭代器return false时，结束递归
    if (result === false) return false
    if (Array.isArray(item[childrenKey])) {
      if (depthTraversal(item[childrenKey], iterator, childrenKey, level + 1) === false) return false
    }
  }
}

/**
 * 调用 iteratee 遍历 tree 中的每个元素(广度优先)
 * 当迭代器return false时，结束递归
 * @param {Array} tree - 树形数据
 * @param {Function} iterator - 迭代器
 * @param {String} childrenKey - 子级数据对应的key
 */
export function breadthTraversal(tree = [], iterator = () => {}, childrenKey = 'children') {
  if (!Array.isArray(tree)) return

  const queue = [...tree]
  const levels = new Array(queue.length).fill(0)

  while (queue.length > 0) {
    const item = queue.shift()
    const level = levels.shift()
    const result = iterator(item, level)

    // 当迭代器return false时，结束循环
    if (result === false) return
    if (Array.isArray(item[childrenKey]) && item[childrenKey].length > 0) {
      const arr = item[childrenKey]
      queue.push(...arr)
      levels.push(...new Array(arr.length).fill(level + 1))
    }
  }
}

/**
 * 调用 iteratee 遍历 tree 中的每个元素(广度优先)
 * 返回每个 iteratee 的返回值结果组成的数组（一维数组）
 * 此函数类似数组map方法，唯一的区别在于遍历的数据是树形数组
 * @param {Array} tree - 树形数据
 * @param {Function} iterator - 迭代器
 * @param {String} childrenKey - 子级数据对应的key
 * @return {Array} 返回每个 iteratee 的返回值结果组成的数组（一维数组）
 */
export function flatTree(tree = [], iterator = () => {}, childrenKey = 'children') {
  if (!Array.isArray(tree)) return

  const queue = [...tree]
  const result = []

  while (queue.length > 0) {
    const item = queue.shift()
    result.push(iterator(item))
    if (Array.isArray(item[childrenKey]) && item[childrenKey].length > 0) queue.push(...item[childrenKey])
  }

  return result
}

// 示例：
// let data = [
//   {
//     key: '1',
//     value: '湖南',
//     children: [
//       {
//         key: '1-1',
//         value: '长沙'
//       },
//       {
//         key: '1-2',
//         value: '株洲'
//       },
//       {
//         key: '1-3',
//         value: '湘潭'
//       }
//     ]
//   },
//   {
//     key: '2',
//     value: '广东',
//     children: [
//       {
//         key: '2-1',
//         value: '广州'
//       },
//       {
//         key: '2-2',
//         value: '深圳'
//       },
//       {
//         key: '2-3',
//         value: '惠州'
//       }
//     ]
//   }
// ]

// 深度遍历data
// depthTraversal(data, item => {
//   console.log(item)
// }, 'children')

// 广度遍历data
// breadthTraversal(data, item => {
//   console.log(item)
// }, 'children')

// const array = flatTree(data, item => item.value, 'children')
// array: ["湖南", "广东", "长沙", "株洲", "湘潭", "广州", "深圳", "惠州"]
